/**
 * DMT Zod schemas (m04).
 */

import { z } from 'zod';
import { InrAmountSchema, UlidSchema, UidSchema } from './common';

export const PaymentModeSchema = z.enum(['IMPS', 'NEFT', 'RTGS', 'UPI']);

export const DmtGeoSchema = z
  .object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuracyM: z.number().positive().max(10_000),
  })
  .optional();

export const InitiateDmtInputSchema = z.object({
  beneficiaryId: UidSchema,
  paymentMethodId: UidSchema,
  amount: InrAmountSchema,
  mode: PaymentModeSchema,
  purpose: z.string().min(1).max(200),
  notes: z.record(z.string(), z.unknown()).optional(),
  geo: DmtGeoSchema,
});

export const SenderOtpRequestSchema = z.object({
  beneficiaryId: UidSchema,
});

export const SenderOtpVerifySchema = z.object({
  beneficiaryId: UidSchema,
  otp: z.string().regex(/^\d{4,6}$/),
  otpRefId: z.string().optional(),
});

export const CancelDmtInputSchema = z.object({
  reason: z.string().max(500).optional(),
});

export type InitiateDmtInput = z.infer<typeof InitiateDmtInputSchema>;
export type SenderOtpVerify = z.infer<typeof SenderOtpVerifySchema>;
